export function getSettingsDialogModalStyle() {
    return {
        main: {
            height: "652px",
            width: "653px",
        },
    };
}
export function getMainStackStyle() {
    return {
        root: {
            height: "581px", //653 - window margins
        },
    };
}
export function getSettingsDialogMainHeaderStackStyle() {
    return {
        root: {
            marginBottom: "20px",
        },
    };
}
export function getBulletIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textDisabled,
            verticalAlign: "middle",
        },
    };
}
export function getEditIconStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.accentTextPrimary,
            marginRight: "10px",
        },
    };
}
export function getDescriptionTextStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textSecondary,
            width: "332px",
        },
    };
}
export function getSubtleLinkStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textTertiary,
        },
    };
}
export function getLinkStyle() {
    return {
        root: {
            textAlign: "right",
        },
    };
}
